const DIVORCE_CASE_VALIDATIONS = {}

export default DIVORCE_CASE_VALIDATIONS
